import ConvertToString from "../../../../../../components/Converter";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function Phi({ delta }) {
  const phi_Formula = `\\displaystyle \\Phi = 0,5 \\cdot \\left[ 1 + \\alpha \\cdot \\left( \\overline{\\lambda} - 0,2\\right) + \\overline{\\lambda}^2\\right]`;
  return (
    <RowBody
      formulaValue={<ToolTip id={"phi_Formula"} type={IconType.FORMULA} formula={phi_Formula} />}
      indicesValue={<span>&Phi;</span>}
      inputValue={<span className="input">{ConvertToString(delta, 1)}</span>}
    />
  );
}

export default Phi;
